module.exports = __webpack_public_path__ + "img/ftc-clay-shoot-trophies-thumb.jpg";